import { render, staticRenderFns } from "./AnexosProcessoAtaDirex.vue?vue&type=template&id=7b367264"
import script from "./AnexosProcessoAtaDirex.vue?vue&type=script&lang=js"
export * from "./AnexosProcessoAtaDirex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports